import { DeleteConfirmDialog } from './delete-confirm-dialog.component';

export type DefaultScreenDeleteConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  defaultScreenName: string | null;
  loading: boolean;
};

export const DefaultScreenDeleteConfirmDialog = ({
  defaultScreenName,
  onClose,
  onConfirm,
  loading,
}: DefaultScreenDeleteConfirmDialogProps) => {
  const message = `This action will delete default screen${
    defaultScreenName ? ` "${defaultScreenName}".` : ''
  }`;

  return (
    <DeleteConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      message={message}
    />
  );
};
